import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa',
    values: {
      clear: 'fa-times',
      complete: 'fa-check'
    }
  },
  theme: {
    themes: {
      light: {
        error: '#f44336',
        success: '#4c9d2f',
        topBar: '#181818',
        primary: '#0076a3'
      }
    }
  }
})
